import { IActionTransition } from 'legacy/lut/classes/models/onboarding/ActionTransition'

import { IForm } from 'core-components/classes/models/IForm'

export const mapActionTransitionFromCrud = (data: IForm[]): IActionTransition[] =>
  data.map((source: IForm) => ({
    EntryId: source.EntryId || 0,
    ActionId: source.ActionId || 0,
    Caption: source.Caption || '',
    Code: source.Code || '',
    AutoCheckCondition: source.AutoCheckCondition || '',
    Strategy: source.Strategy,
    RequestId: source.RequestId || 0,
    Process: source.Process || '',
    Triggers: source.Triggers || '',
    ActionUUID: source.ActionUUID || '',
    AllowHandClose: source.AllowHandClose || 0,
    UUID: source.UUID || '',
    Notifications: source.Notifications || '',
    SortOrder: source.SortOrder || 0,
    StrategyMeta: source.StrategyMeta || '',
    CollectedData: source.CollectedData || '',
    RequestTemplateUUID: source.RequestTemplateUUID || '',
    RejectReason: source.RejectReason || '',
  }))
